<template>
  <div :class="{ 'pointer-events-none': isLoading }" class="relative">
    <DataGetter
      @dataAvailable="
        data => {
          options = formatOptionsFromData(data)
          this.isLoading = false
          $forceUpdate()
        }
      "
      @beforeGetting="isLoading = true"
      :searchQuery="formatSearchQuery(value)"
      :contentId="optionsContentId"
      eventToListen="none"
      :debounceDelay="500"
    />
    <SelectInput
      :value="value"
      @input="
        val => {
          $emit('input', val)
          $emit('input:modelValue', val)
          $emit('update:modelValue', val)
        }
      "
      ref="selectInput"
      :preventKeyDown="false"
      :label="label"
      :detailText="detailText"
      :required="required"
      :disabled="disabled"
      :placeHolder="placeHolder"
      :prefix="prefix"
      :suffix="suffix"
      :alwaysShowPrefix="alwaysShowPrefix"
      :alwaysShowSuffix="alwaysShowSuffix"
      :formatInputToValue="formatInputToValue"
      :preventOptionSelect="preventOptionSelect || isLoading"
      :formatOptionsDisplay="
        isLoading
          ? () =>
              `<div class='absolute top-0 left-0 w-full h-full shimmerElementRoundedDefault'></div>`
          : formatOptionsDisplay
      "
      :formatOptionInputDisplay="
        isLoading
          ? formatOptionInputDisplay || formatOptionsDisplay
          : formatOptionInputDisplay
      "
      :options="optionsUsed"
      :optionsAreSame="optionsAreSame"
    />
    <div
      v-if="isLoading"
      class="shimmerElementRoundedDefault top-0 left-0 absolute w-full h-full"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import SelectInput from './SelectInput.vue'

export default defineComponent({
  name: 'AutocompletInput',
  components: {
    SelectInput,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    detailText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    alwaysShowPrefix: {
      type: Boolean,
      default: false,
    },
    alwaysShowSuffix: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Function,
      default: () => {
        return ''
      },
    },
    preventOptionSelect: {
      type: Boolean,
      default: false,
    },
    optionsAreSame: {
      type: Function,
      default: null,
    },
    formatInputToValue: {
      type: Function,
      default: null,
    },
    formatOptionsDisplay: {
      type: Function,
      default: null,
    },
    formatOptionInputDisplay: {
      type: Function,
      default: null,
    },
    formatSearchQuery: {
      type: Function,
      default: null,
    },
    formatOptionsFromData: {
      type: Function,
      default: null,
    },
    optionsContentId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputText: '',
      selectedOption: null,
      options: [],
      isLoading: true,
    }
  },
  mounted() {},
  methods: {
    reloadInputContent() {
      this.$refs.selectInput.reloadInputContent()
    },
    externalSetValue(...args) {
      this.$refs.selectInput.externalSetValue(...args)
    },
  },
  computed: {
    optionsUsed() {
      return this.isLoading
        ? this.options[0]
          ? this.options
          : [
              { shimmer: true },
              { shimmer: true },
              { shimmer: true },
              { shimmer: true },
            ]
        : this.options
    },
  },
  watch: {},
})
</script>
